import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      margin: [Spacings.s56, Spacings.s0],
    },
  }),
  { name: 'brands-stats' },
);

export default useStyles;
